export default "__VITE_ASSET__0ak$jW5X__"